/**
 * @fileoverview CATMS Crew PWA - Geolocation Hook
 * @description GPS location acquisition for timestamps
 */

import { useState, useCallback } from 'react';

interface GeoPosition {
  latitude: number;
  longitude: number;
}

export function useGeolocation() {
  const [position, setPosition] = useState<GeoPosition | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const getPosition = useCallback((): Promise<GeoPosition | null> => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        setError('Geolocation is not supported');
        resolve(null);
        return;
      }
      setLoading(true);
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const geo = { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
          setPosition(geo);
          setError(null);
          setLoading(false);
          resolve(geo);
        },
        (err) => {
          setError(err.message);
          setLoading(false);
          resolve(null);
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
      );
    });
  }, []);

  return { position, error, loading, getPosition };
}
